import React from 'react';
import { useSpring, animated } from 'react-spring';

import"../../CSS/ProjectPageStyle.css";

const WorkExperience = () => {
    const props = useSpring({
        opacity: 1,
        color: 'white',
        from: { opacity: 0 },
        delay: '2000'
    })
    return (
    <animated.div style={props}>
        <div className="project-page">
            <div className="project-title">Work Experience</div>
            <div className="experience-block">
                <div className="cv-box">
                    <div className="cv-box-title">Senior Software Engineer, SLB</div>
                    <div className="cv-box-date">Oct 2024 - Current</div>
                </div>
                <div className="cv-box-tech">Python, Go, GCP, Angular</div>
                <ul>
                    <li>Developed a Go-based constrained optimisation algorithm for field development planning, extending pipeline routing beyond straight-line modelling to support bending-radius constraints, polygonal exclusion zones, and cost-aware route generation from PoC through production deployment.</li>
                    <li>Building Python tooling in Dataiku for LLM-driven agentic workflows, enabling clients to run a field-layout and reservoir-target placement engine through natural-language inputs, REST tool calls, and validated workflow execution rather than manually editing input files.</li>
                    <li>Migrated a full Python optimisation engine to Go to address performance bottlenecks on large-scale field layouts, preserving behavioural parity through integration tests and packaging the engine as licensed Windows/Linux executables for improved portability across desktop and Dataiku environments.</li>
                </ul>
            </div>
            <div className="experience-block">
                <div className="cv-box">
                    <div className="cv-box-title">Data Engineer, SLB</div>
                    <div className="cv-box-date">Oct 2020 - 2024</div>
                </div>
                <div className="cv-box-tech">Python, Spark, Databricks, Azure, Angular</div>
                <ul>
                    <li>Designed and built near real-time data pipelines for disparate challenging data sets such as satellite, drone, and IoT measurement data in a managed Spark environment in Azure Databricks.</li>
                    <li>Improved field-test readiness by automating a previously manual device-localisation workflow, reducing operational effort, and establishing a reusable Python microservice pattern.</li>
                    <li>Collaborated closely with researchers to convert proof of concept algorithms into production code and developed tooling to assist the development and verification process.</li>
                    <li>Organised internal company events such as hackathons, supported recruitment initiatives at university fairs and mentored interns/junior engineers.</li>
                    <li>Communicated with business and domain experts to develop dashboards for rapid value proposition to assess new data sources for business requirements using Power BI.</li>
                    <li>Served as Databricks SME for product data-processing pipelines, advising engineers and researchers on PySpark, data quality, Medallion architecture, service-principal authentication, and Databricks cost optimisation.</li>
                    <li>Delivered a zero-downtime Databricks infrastructure migration from deprecated DBFS init scripts to Azure Blob/ABFSS storage, protecting active client field tests from measurement-data gaps.</li>
                    <li>Led security-scan governance across Python and Golang repositories using MEND, Trivy, and AppScan, helping the cloud team address vulnerabilities required for controlled commercial release.</li>
                </ul>
            </div>
            <div className="experience-block">
                <div className="cv-box">
                    <div className="cv-box-title">Software Engineer Internship, SLB</div>
                    <div className="cv-box-date">April 2019 - July 2020</div>
                </div>
                <div className="cv-box-tech">Python, NLP, MA, SQLite3</div>
                <ul>
                    <li>Researched methods for improving extracted data insights from oilfield documents using Natural Language Processing (NLP) and Machine Arguing (MA) methods.</li>
                    <li>Used a Jupyter Notebook for experimentation with a custom python library for the NLP functionality.</li>
                    <li>Implemented case-based reasoning using abstract argumentation and an entity linking system defined in research papers from scratch in Python.</li>
                </ul>
            </div>
        </div>
    </animated.div>
    )
}

export default WorkExperience;
